module.exports = __webpack_public_path__ + "static/media/st.ef6bb47c.svg";